module.exports = __webpack_public_path__ + "img/130027.a3a9b099.png";